module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2018/december-6ae834ae855698f0db79b00d5b1471c2.png";